module.exports = __webpack_public_path__ + "img/suit.146c7cc7.png";